"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _dateFormatting = _interopRequireDefault(require("@insided/shared/utils/dateFormatting"));

var LastActiveCell = function LastActiveCell() {
  return function (_ref) {
    var lastActive = _ref.lastActive,
        isInvite = _ref.isInvite;

    if (!lastActive) {
      return null;
    }

    return (0, _preact.h)("div", {
      className: "team-overview__table-last-active"
    }, isInvite ? lastActive : (0, _dateFormatting.default)(lastActive));
  };
};

var _default = LastActiveCell;
exports.default = _default;